////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep, findIndex, filter, merge, map, isEmpty } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const scheduledPromoManager = {
	[ActionsTypes.GET_SCHEDULED_PROMO]: (state) =>
		update(state, {
			scheduledPromoManager: {
				isLoading: {
					$set: true,
				},
				items: {
					$set: [],
				},
			},
			columns: {
				currentDir: {
					$set: '',
				},
				currentColumn: {
					$set: '',
				},
			},
		}),
	[ActionsTypes.GET_SCHEDULED_PROMO_SUCCESS]: (state, payload) => {
		let payloadFiltersCP = cloneDeep(payload.data.headerParam.filters)
		const paging = {
			totalElements: payload.data.headerContent.contentPagined.totalElements,
			totalPages: payload.data.headerContent.contentPagined.totalPages,
		}
		// payload.data.headerContent.contentPagined.content.forEach(elem => elem['promotionItemLines'] = [])

		let items = cloneDeep(payload.data.headerContent.contentPagined.content)

		if (payload.idPromo > 0) {
			items = filter(items, { id: payload.idPromo })
		}

		items = map(items, (e, k) => {
			// For test
			/*if (!payload.toggledLines) {
				if (k === 0) e.priceCampaignLines = null
				else e.priceCampaignLines = ''
				if (isEmpty(e.promotionItemLines)) e.promotionItemLines = null
			}*/

			if (payload.toggledLines) {
				e.toggleNested = true
			}
			return e
		})

		return update(state, {
			scheduledPromoManager: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: items,
				},
				paging: {
					$set: paging,
				},
				header: {
					$set: payloadFiltersCP,
				},
			},
		})
	},
	[ActionsTypes.GET_SCHEDULED_PROMO_FAILURE]: (state, payload) =>
		update(state, {
			scheduledPromoManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.GET_SCHEDULED_PROMO_UNIT]: (state) =>
		update(state, {
			scheduledPromoManager: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.GET_SCHEDULED_PROMO_UNIT_SUCCESS]: (state, payload) => {
		const promoListCP = cloneDeep(state.scheduledPromoManager.items)
		const payloadPromo = payload.data
		const idx = findIndex(promoListCP, { id: payloadPromo.id })

		if (idx > -1) promoListCP[idx] = merge(payloadPromo, promoListCP[idx])

		return update(state, {
			scheduledPromoManager: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: promoListCP,
				},
			},
		})
	},
	[ActionsTypes.GET_SCHEDULED_PROMO_UNIT_FAILURE]: (state, payload) =>
		update(state, {
			scheduledPromoManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.GET_TRANSMISSION_PROMO]: (state) =>
		update(state, {
			scheduledPromoManager: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.GET_TRANSMISSION_PROMO_SUCCESS]: (state, payload) => {
		return update(state, {
			scheduledPromoManager: {
				isLoading: {
					$set: false,
				},
				transmission: {
					$set: payload.data,
				},
			},
		})
	},
	[ActionsTypes.GET_TRANSMISSION_PROMO_FAILURE]: (state, payload) =>
		update(state, {
			scheduledPromoManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.GET_PROMO_CAMPAIGN_NESTED_LINES]: (state) =>
		update(state, {
			scheduledPromoManager: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.GET_PROMO_CAMPAIGN_NESTED_LINES_SUCCESS]: (state, payload) => {
		const scheduledPromoItems = cloneDeep(state.scheduledPromoManager.items)

		const fIndex = findIndex(scheduledPromoItems, { id: payload.data.id })
		if (fIndex > -1) {
			scheduledPromoItems[fIndex] = payload.data
			scheduledPromoItems[fIndex].toggleNested = true
		}
		return update(state, {
			scheduledPromoManager: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: scheduledPromoItems,
				},
			},
		})
	},
	[ActionsTypes.GET_PROMO_CAMPAIGN_NESTED_LINES_FAILURE]: (state, payload) =>
		update(state, {
			scheduledPromoManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.RESET_SCHEDULED_PROMO_MANAGER_ITEMS]: (state, _payload) => {
		return update(state, {
			scheduledPromoManager: {
				items: {
					$set: [],
				},
			},
		})
	},
}

export default scheduledPromoManager
